<template>
    <div class="province">
        <el-select v-model="sheng" value-key="id" placeholder="省份" @change="cksheng">
            <el-option
            v-for="item in shenglist"
            :key="item.id"
            :label="item.name"
            :value="item">
            </el-option>
        </el-select>
        <el-select v-model="shi" value-key="id" placeholder="城市" @change="ckshi">
            <el-option
            v-for="item in shilist"
            :key="item.id"
            :label="item.name"
            :value="item">
            </el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    name:'province',
    props:{
        
    },
    data(){
        return{
            userdata:{},
            region:[],
            sheng:'',
            shenglist:[],
            shi:'',
            shilist:[],
            ageRegion:{}
        }
    },
    created(){
    },
    mounted(){
        let userdata = JSON.parse(sessionStorage.getItem('userdata'))
        this.$set(this,'userdata',userdata)
        let region = JSON.parse(localStorage.getItem('region'))
        this.$set(this,'region',region)
        let newCity = []
        region.forEach(x => {
            if(x.level==0){
                this.shenglist.push(x)
                this.sheng = x
                if(userdata.level == 0){
                    this.addNext(x.id,0)
                }
            }
            if(userdata.level >= 1){
                if(x.level==1){
                    newCity.push(x)
                }
            }
        });
        // 市区回显
        if(newCity.length==1){
            this.shilist = newCity
            this.shi = newCity[0]
            if(userdata.level == 1){
                this.addNext(newCity[0].id,1)
            }
        }else if(newCity.length==0){
            this.shilist = []
            this.shi = ''
        }else{
            this.shilist = newCity
        }
    },
    methods:{
        // 当前选中只有一级的时候自动获取下一级地区
        addNext(regId,stat){
            this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:regId}),{headers:{accessToken:this.userdata.token}})
            .then(res=>{
                if(res.data.success){
                    if(stat == 0){
                        this.$set(this,'shilist',res.data.areaListInfoList)
                    }else if(stat == 1){
                        this.$set(this,'qulist',res.data.areaListInfoList)
                    }else if(stat == 2){
                        this.$set(this,'zhenlist',res.data.areaListInfoList)
                    }else if(stat == 3){
                        this.$set(this,'cunlist',res.data.areaListInfoList)
                    }
                }
            })
        },
        cksheng(val){
            // 重新选择了省编辑
            if(this.userdata.level==0){
                this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:val.id}),{headers:{accessToken:this.userdata.token}})
                .then(res=>{
                    if(res.data.success){
                        this.$set(this,'shilist',res.data.areaListInfoList)
                    }
                })
                this.$emit('gain',val);
            }else{
                this.region.forEach(x=>{
                    if(x.level==1){
                        this.shilist.push(x)
                    }
                })
                this.$emit('gain','');
            }
            this.$set(this,'shi','')
        },
        ckshi(val){
            this.$emit('gain',val);
        }
    }
}
</script>
<style>
    .province{
        display: flex
    }
    .province .el-select{
        margin-right:16px;
    }
</style>